import React from 'react'

const sriLanka4 = {
    id: 'srilanka-sigiriya',
    type: 'post',
    countryId: 'sriLanka',
    title: 'Peaceful Relaxation in Sigiriya',
    longDate: 'March 18, 2019',
    month: 'Mar',
    date: '18',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sl4cover.jpg',
    content: [
        {
            text: (
                <div>After a fast pace traveling through south and central Sri Lanka, Peter and I were tired and ready for some chill time. Most people do Sigiriya and Pidurangala in a day – you can do it as a day trip from Kandy in a private car, or take the bus via Dambulla and spend one night to be there at sunrise. We decided to go even slower, and spend one day getting to and hanging out in Dambulla, then two nights in Sigiriya.</div>
            )
        },
        {
            text: (
                <div>As it turned out, there's not a whole lot to do in that area. Dambulla has a cave temple, but when we walked over there and found out the price was 1500 rupees each ($8.40) we balked and realized we didn't even have enough cash on us. It was definitely a cheap backpacker moment – all the awesome caves we'd been to in Thailand and Vietnam were either free or $2-3. We might have gone even with that price, but since we knew Sigiriya would be $30 each, decided to skip it. If you're headed to Sri Lanka, I would not recommend spending any time there outside the temple; there's almost nothing to do except a few food spots, it's not terribly walkable, and there are no cafes where you can hang out for a few hours.</div>
            )
        },
        {
            text: (
                <div>On the other hand, Sigiriya – the town built up around Sirigiya rock and temple – was lovely. It's a tiny town with one street of restaurants and lots of wide open red dirt roads (most of the nice hotels are tucked on private drives surrounded by jungle, and the best ones offer uninhibited views of the rock). Pidurangala rock is only a twenty to thirty minute walk away; it offers the best views of Sigiriya, and is popular for sunrise and sunset. We opted to stay next to the base of Pidurangala so we could easily get there for sunrise.</div>
            )
        },
        {
            text: (
                <div>Since we had two nights and were in no rush, we ended up spending the entire first afternoon drinking lime juice and lying around the hammocks. <a href="https://www.booking.com/hotel/lk/thal-sewana.html">Our guesthouse</a> didn't have working wifi, but it did have a fantastic cook, so there really was no reason for us to leave. I got through two books and finished off my audiobook just while we were there.</div>
            )
        },
        {
            text: (
                <div>With sunrise at 6:20 a.m., we got up at 5:15 to walk over and make the sweaty 20 minutes climb up through the humid jungle. I made a rookie mistake with this one... I wore my cute long skirt, since I knew I needed to cover knees and shoulders to get through the temple at the base. I also wore flip flops, and this hike turned into pure bouldering at the top – as in, clambering and jumping over massive boulders, with a rope involved to pull yourself up at the end. Don't be me! Wear sensible clothes for a hike!</div>
            )
        },
        {
            text: (
                <div>There were a couple dozen other tourists on the rock awaiting the sunrise, but it didn't feel crowded. We'd all rock climbed up here and now everyone sat gently panting and peacefully waiting for the pink and yellow light to arrive. The sunrise was gradual and muted, and it was beautiful to see the trees below slowly take shape and shift in color.</div>
            )
        },
        {
            text: (
                <div>I'm a morning person, so when we'd gotten back down the rock I was jazzed and ready to explore the area a bit. Peter opted for more reading time in the hammock, so I walked the 30 minutes into town to rent a bike at Kumari Grocery. I cycled around the countryside for an hour or so, around the back side of Pidurangala. At one point I screeched to a halt when I saw a large snake slithering across the road – it was the full width of the road, so about 5-6 feet. A woman rushed out from the nearest house and asked "Cobra?" with a worried face, then saw its tail and laughed with relief, telling me this one wasn't dangerous. I'd never seen a snake that large and waited to make sure it went far away before I kept biking.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/pidurangala.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/pidurangala3.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/pidurangala4.jpg']
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/pidurangala5.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/pidurangala6.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya2.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya3.jpg'
        },
        {
            text: (
                <div>In the late afternoon, Peter and I walked over to the Sigiriya rock main entrance and coughed up our $60 (ouch). It was a much longer walk to the top, though there were stairs and steps the whole way, where Pidurangala had had a jungle path. At this point, I found it really difficult to get up to the top even with several breaks. I'm blaming it on the extreme heat, to which I never adapted, and the fact that we'd done a <a href="https://worldofwander.app/post/srilanka-knuckles">42km hike a couple of days ago</a> and I hadn't recovered.</div>
            )
        },
        {
            text: (
                <div>The ruins at the top were well worth the pain. We stupidly had not brought water since we didn't want to carry the weight up, and got to the top in forty minutes as predicted - but were way too early for the sunset. Since the sunrise that morning hadn't been as spectacular or colorful as others we've been lucky enough to see at other points on our trip, we decided to head back while it was still light out. <a href="https://www.journeyera.com/sri-lanka-day-2-photo-journal-sigiriya-sunrise-sunset/">Here's a post</a> from someone who did stick around until it was dark, and got amazing photos! Sigiriya and Pidurangala were definitely a highlight of Southeast Asia for me, and I'm so glad we took the time to do it slowly (for once).</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya4.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya5.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya6.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya7.jpg']
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya8.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya9.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya10.jpg']
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya11.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/sriLanka/srilanka-sigiriya/sigiriya12.jpg'
        },
        {
            text: (
                <div>
                    <b>More from Sri Lanka:</b><br />
                    <a href="https://worldofwander.app/post/sriLanka-south-coast">Hot &amp; Sandy in Sri Lanka: Colombo and the South Coast</a><br />
                    <a href="https://worldofwander.app/post/sriLanka-ella-kandy">Ella to Kandy: Trains and Tea Farms</a><br />
                    <a href="https://worldofwander.app/post/sriLanka-knuckles">Hiking Knuckles Mountain</a><br />
                </div>

            )
        }
    ]
}


export default sriLanka4


// WEBPACK FOOTER //
// ./src/Posts/Content/sriLanka4.js